// extracted by mini-css-extract-plugin
export default {"reviewModalMobile":"_39ypky"};